<template>
<el-collapse-item :name="item.id">
    <template slot="title">
      <div class="row pad">
        <div class="col s1 mm yo-align-right yo-text-n">{{item.numero}}</div>
        <div class="col s9 m10m yo-text-n" :style="(item.primo==1) ? 'text-decoration: underline' : ''">{{item.cognome}}&#160;{{item.nome}}</div>
        <!--
        <div class="col s1 red yo-text-bold yo-align-right" v-if="item.nr_numero>10" style="">{{item.nr_numero}}&#160;&#160;<i class="material-icons" style="float:right;margin-right:12px;line-height:48px;">error</i></div>
        <div class="col s1 tree_poppy yo-text-bold yo-align-right" v-if="item.nr_numero>0 && item.nr_numero<11" style="">{{item.nr_numero}}&#160;&#160;<i class="material-icons" style="float:right;margin-right:12px;line-height:48px;">warning</i></div>
        <div class="col s1 grees yo-text-bold yo-align-right" v-if="item.nr_numero==0" style=""><i class="material-icons" style="float:right;margin-right:12px;line-height:48px;">done</i></div>
         -->
      </div>
    </template>
    
    <div class="row pad">
      <div class="col s12 m10m offset-mm" v-html="affiliazionesupiurighe"></div>
   </div>

   <div class="row" style="margin-top:12px;border-top:1px solid #5288C6;">
     <div class="col s6 m5 " style="margin-top:12px;" v-on:click="rowDel()">
        <div class="yo-button small yo-color-secondary yo-text-bold"  ><i class="material-icons " style="float:left;padding:0 12px 0 18px;" >delete</i><div>DELETE AUTHOR</div></div>
      </div>

      <div class="col s6 m3m yo-align-left" style="margin-top:12px;" v-if="item.primo!=1" v-on:click="goFirst()">
        <div class="yo-button small yo-color-primary yo-text-bold"  ><i class="material-icons " style="float:left;padding:0 12px 0 18px;" >looks_one</i><div>MAKE PRESENTING AUTHOR</div></div>
      </div>
      <div class="col s6 m3m yo-align-left" style="margin-top:12px;" v-else>&#160;</div>


      <div class="col s6 m2 yo-align-right" style="margin-top:12px;" v-on:click="goUp()" v-if="item.numero>1">
        <div class="yo-button small yo-color-primary yo-text-bold"  ><i class="material-icons " style="float:left;padding:0 12px 0 18px;" >keyboard_arrow_up</i><div>MOVE UP</div></div>
      </div>
      <div class="col s6 m2 yo-align-left" style="margin-top:12px;" v-else>&#160;</div>

      <div class="col s6 m1m yo-align-left" style="margin-top:12px;" v-on:click="goDown()" v-if="item.numero<$abstract._autore.length">
        <div class="yo-button small yo-color-primary yo-text-bold"  ><i class="material-icons " style="float:left;padding:0 12px 0 18px;" >keyboard_arrow_down</i><div>MOVE DOWN</div></div>
      </div>
      <div class="col s6 m1m yo-align-left" style="margin-top:12px;" v-else>&#160;</div>

      
    </div>


</el-collapse-item>
</template>


<script>
export default {
  name: 'item-elenco',
  created () {
    this.$teras.pageHeader = 80
  },
  mounted () {
    this.$emit('scrollTop', 0)
  },
  props: {
    item: Object
  },
    methods: {
      rowDel () {
        this.$confirm('The author "'+this.item.cognome+' '+this.item.nome+'" will be eliminated?', 'Warning', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'warning'
        }).then(() => {
          var parent = this
          this.$axios.deleteRow(this.item.id,'abstract_autore').then((data) => {
              this.$abstract.getAutori()
              this.$contatto.getAbstract()
          })
        }).catch(() => {
          this.$message({
              type: 'Alert',
              message: 'Operation canceled'
          })         
        })
        
      },
      async goUp() {
          this.$abstract.resetPreview()
          this.$axios.query('doQuery',`UPDATE abstract_autore SET numero=(numero+1) WHERE abstract=←abstract AND numero=←numero`,{numero: this.item.numero-1, abstract: this.item.abstract}).then(async (response) => {
            console.log(response)

            this.$axios.query('doQuery',`UPDATE abstract_autore SET numero=(numero-1) WHERE id=←id`,{ id: this.item.id}).then(async (response) => {
               console.log(response)
               this.$abstract.getAutori()
               this.$contatto.getAbstract()
               
            })
            
         })

      },

      async goDown() {
          this.$abstract.resetPreview()
          this.$axios.query('doQuery',`UPDATE abstract_autore SET numero=(numero-1) WHERE abstract=←abstract AND numero=←numero`,{numero: this.item.numero+1, abstract: this.item.abstract}).then(async (response) => {
            console.log(response)

            this.$axios.query('doQuery',`UPDATE abstract_autore SET numero=(numero+1) WHERE id=→id`,{id: this.item.id}).then(async (response) => {
               console.log(response)
               this.$abstract.getAutori()
               this.$contatto.getAbstract()
            })
            
         })

      },

      async goFirst() {
        this.$abstract.resetPreview()
        await this.$axios.query('doQuery',`UPDATE abstract_autore SET primo=0 WHERE abstract=←abstract`,{abstract: this.item.abstract})
        await this.$axios.query('doQuery',`UPDATE abstract_autore SET primo=1 WHERE id=→id`,{id: this.item.id})
        this.$abstract.profile.row.emailprimoautore=''
        this.$abstract.getAutori()
        this.$contatto.getAbstract()

         /*
         this.$axios.query('doQuery',`UPDATE abstract_autore SET primo=0 WHERE abstract=←abstract`,{abstract: this.item.abstract}).then(async (response) => {
            console.log(response)

            this.$axios.query('doQuery',`UPDATE abstract_autore SET primo=1 WHERE id=→id`,{id: this.item.id}).then(async (response) => {
               console.log(response)
               this.$abstract.getAutori()
               this.$contatto.getAbstract()
            })
            
         })
         */
      
      }
   },
   computed: {
      affiliazionesupiurighe:function() {
         return this.item.affiliazione.replace(/(?:\r\n|\r|\n)/g, '<br>')
      }
   }
}
</script>

<style>

</style>
